/**
 * M7 S32: open leads and open questions (spec §2.6). A lead's only guidance is *set nav target*; a question is read,
 * not pressed, and closes when a claim answers it.
 */
import type { ReactNode } from 'react'
import type { LogsConfig } from './models/config'
import type { LeadRow, QuestionRow } from './models/logs'

export interface LeadsProps {
  leads: readonly LeadRow[]
  questions: readonly QuestionRow[]
  config: LogsConfig
  /** The focused lead row, or -1. */
  focusedRow: number
  onSetNav: (index: number) => void
}

export function Leads(p: LeadsProps): ReactNode {
  const c = p.config
  return (
    <>
      <section className="lg-section" data-testid="logs-leads">
        <h3 className="lg-section__title">{c.leads.heading}</h3>
        {p.leads.length === 0 ? (
          <p className="sui-empty">{c.empty.leads}</p>
        ) : (
          <ul className="lg-list">
            {p.leads.map((l, i) => (
              <li key={l.logId} className="lg-row" data-testid="logs-lead" data-log={l.logId} {...(p.focusedRow === i ? { 'data-focused': '' } : {})}>
                <span className="lg-row__title">{l.title}</span>
                <span className="lg-row__meta">{l.pointsTo}</span>
                <button
                  type="button"
                  tabIndex={-1}
                  className="sui-btn lg-btn"
                  data-testid="logs-set-nav"
                  {...(p.focusedRow === i ? { 'data-focused': '' } : {})}
                  onClick={() => p.onSetNav(i)}
                >
                  {c.leads.setNav}
                </button>
              </li>
            ))}
          </ul>
        )}
      </section>
      <section className="lg-section" data-testid="logs-questions">
        <h3 className="lg-section__title">{c.questions.heading}</h3>
        {p.questions.length === 0 ? (
          <p className="sui-empty">{c.empty.questions}</p>
        ) : (
          <ul className="lg-list">
            {p.questions.map((q) => (
              <li key={q.id} className="lg-row" data-testid="logs-question" data-question={q.id}>
                <span className="lg-row__title">{q.text}</span>
              </li>
            ))}
          </ul>
        )}
      </section>
    </>
  )
}
